import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { AuditoriaConferenciaCaixaGeral } from '../domain/auditoria-conferencia-caixa-geral.model';

export class AuditoriaConferenciaCaixaGeralSerializer extends DomainSerializer<AuditoriaConferenciaCaixaGeral> {}
